// // import React, { useState, useEffect, useRef } from "react";
// // import { ChevronLeft, ChevronRight } from "lucide-react";

// // /* ─────────────────────────────────────────────────────
// //    DATA — 6 real client Instagram profiles
// // ───────────────────────────────────────────────────── */
// // const PROFILES = [
// //   {
// //     handle: "designwalls_wallpapers",
// //     name: "Design Walls",
// //     category: "Home decor",
// //     posts: "343",
// //     followers: "8,969",
// //     following: "4",
// //     bio: "Award-winning #wallpaper Company🏆\nDiscover Blinds & Curtains @designwalls_furnishings",
// //     verified: true,
// //     avatar: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=80&h=80&fit=crop",
// //     highlights: [
// //       { label: "Why us?",     img: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=60&h=60&fit=crop" },
// //       { label: "Our Collection", img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=60&h=60&fit=crop" },
// //       { label: "Sabyasachi",  img: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=60&h=60&fit=crop" },
// //       { label: "Festives",    img: "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=60&h=60&fit=crop" },
// //       { label: "Behind walls",img: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=60&h=60&fit=crop" },
// //       { label: "R & D",       img: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=60&h=60&fit=crop" },
// //     ],
// //     feed: [
// //       "https://images.unsplash.com/photo-1615873968403-89e068629265?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1497366216548-37526070297c?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=200&h=200&fit=crop",
// //     ],
// //     accentColor: "#E31E24",
// //     tag: "Interior Design",
// //   },
// //   {
// //     handle: "dps_amaravati",
// //     name: "Delhi Public School Amaravati",
// //     category: "School",
// //     posts: "810",
// //     followers: "1,283",
// //     following: "0",
// //     bio: "At Delhi Public School, an outstanding learning experience awaits your child.\nAmaravati Rd, Lam, Andhra Pradesh, Amaravathi, Guntur district 522034",
// //     verified: false,
// //     avatar: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=80&h=80&fit=crop",
// //     highlights: [
// //       { label: "Special Days", img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=60&h=60&fit=crop" },
// //       { label: "Gallery",      img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=60&h=60&fit=crop" },
// //       { label: "Celebrations", img: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=60&h=60&fit=crop" },
// //       { label: "DPS Edge",     img: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=60&h=60&fit=crop" },
// //       { label: "Testimonials", img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=60&h=60&fit=crop" },
// //     ],
// //     feed: [
// //       "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=200&h=200&fit=crop",
// //     ],
// //     accentColor: "#2E7D32",
// //     tag: "Education",
// //   },
// //   {
// //     handle: "hyd.art.gallery",
// //     name: "hyd.art",
// //     category: "Art gallery",
// //     posts: "239",
// //     followers: "1,811",
// //     following: "9",
// //     bio: "🛒 Buy beautiful and original artworks\n🖼️ Paintings, prints, sculptures & more\n🎨 Made by talented artists from all over...",
// //     verified: false,
// //     avatar: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=80&h=80&fit=crop",
// //     highlights: [
// //       { label: "Artworks",  img: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=60&h=60&fit=crop" },
// //       { label: "Artists",   img: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=60&h=60&fit=crop" },
// //       { label: "Events",    img: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=60&h=60&fit=crop" },
// //       { label: "Spotlight", img: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=60&h=60&fit=crop" },
// //     ],
// //     feed: [
// //       "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?w=200&h=200&fit=crop",
// //     ],
// //     accentColor: "#C0392B",
// //     tag: "Art & Culture",
// //   },
// //   {
// //     handle: "milletmarvels",
// //     name: "Millet Marvels",
// //     category: "Food & nutrition",
// //     posts: "573",
// //     followers: "9,621",
// //     following: "27",
// //     bio: "MILLET EXPERIENCE HUB is here!\nServing 100% wholegrain goodness...",
// //     verified: false,
// //     avatar: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=80&h=80&fit=crop",
// //     highlights: [
// //       { label: "Offers",      img: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=60&h=60&fit=crop" },
// //       { label: "Menu",        img: "https://images.unsplash.com/photo-1547592180-85f173990554?w=60&h=60&fit=crop" },
// //       { label: "Festivities", img: "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=60&h=60&fit=crop" },
// //       { label: "Press",       img: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=60&h=60&fit=crop" },
// //       { label: "Reviews",     img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=60&h=60&fit=crop" },
// //     ],
// //     feed: [
// //       "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1547592180-85f173990554?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=200&h=200&fit=crop",
// //     ],
// //     accentColor: "#F86C3D",
// //     tag: "Food Brand",
// //   },
// //   {
// //     handle: "zuriskinclinic",
// //     name: "Zuri Skin Clinic",
// //     category: "Healthcare · Beauty",
// //     posts: "412",
// //     followers: "5,840",
// //     following: "18",
// //     bio: "✨ Awaken Your Glow!\nConsult with our Dermatologists for all your skin concerns.\nBook: 9505097171",
// //     verified: false,
// //     avatar: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=80&h=80&fit=crop",
// //     highlights: [
// //       { label: "Services",   img: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=60&h=60&fit=crop" },
// //       { label: "Results",    img: "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=60&h=60&fit=crop" },
// //       { label: "Doctors",    img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=60&h=60&fit=crop" },
// //       { label: "Reviews",    img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=60&h=60&fit=crop" },
// //       { label: "Offers",     img: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=60&h=60&fit=crop" },
// //     ],
// //     feed: [
// //       "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=200&h=200&fit=crop",
// //     ],
// //     accentColor: "#9C27B0",
// //     tag: "Healthcare",
// //   },
// //   {
// //     handle: "triumph.hyderabad",
// //     name: "Triumph Motorcycles Hyd",
// //     category: "Automotive · Retail",
// //     posts: "1,841",
// //     followers: "12,400",
// //     following: "12",
// //     bio: "🏍️ Authorised Triumph Dealer — Hyderabad\nRoad: Retro, Scrambler, Bonneville, Tiger Series\nTest ride & more ↓",
// //     verified: false,
// //     avatar: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=80&h=80&fit=crop",
// //     highlights: [
// //       { label: "Araku 26",     img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=60&h=60&fit=crop" },
// //       { label: "Scrambler 40", img: "https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=60&h=60&fit=crop" },
// //       { label: "Customer V.",  img: "https://images.unsplash.com/photo-1590212151175-e58edd96185b?w=60&h=60&fit=crop" },
// //       { label: "Events",       img: "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=60&h=60&fit=crop" },
// //     ],
// //     feed: [
// //       "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1590212151175-e58edd96185b?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1449426468159-d96dbf08f19f?w=200&h=200&fit=crop",
// //       "https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=200&h=200&fit=crop",
// //     ],
// //     accentColor: "#FF6F00",
// //     tag: "Automotive",
// //   },
// // ];

// // /* ─────────────────────────────────────────────────────
// //    CSS
// // ───────────────────────────────────────────────────── */
// // const CSS = `
// // @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

// // .ig-sec {
// //   padding: 100px 0 120px;
// //   background: #0D0806;
// //   overflow: hidden;
// //   position: relative;
// // }
// // .ig-sec * { box-sizing: border-box; }

// // /* bg glow */
// // .ig-bg1 { position:absolute;top:-160px;right:-120px;width:560px;height:560px;border-radius:50%;background:radial-gradient(circle,rgba(248,108,61,.1),transparent 70%);pointer-events:none;animation:igob 8s ease-in-out infinite }
// // .ig-bg2 { position:absolute;bottom:-100px;left:-80px;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(217,87,46,.07),transparent 70%);pointer-events:none;animation:igob 11s ease-in-out infinite reverse }
// // @keyframes igob { 0%,100%{transform:scale(1)} 50%{transform:scale(1.12)} }

// // /* inner */
// // .ig-in { max-width:1280px;margin:0 auto;padding:0 44px;position:relative;z-index:1; }

// // /* header */
// // .ig-hd { display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:56px;flex-wrap:wrap;gap:28px }
// // .ig-hd-left {}
// // .ig-tag { display:inline-flex;align-items:center;gap:7px;background:rgba(248,108,61,.1);border:1px solid rgba(248,108,61,.28);border-radius:100px;padding:6px 16px;font-family:"DM Sans",sans-serif;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#FF8A5C;margin-bottom:16px }
// // .ig-tag-dot { width:6px;height:6px;background:#F86C3D;border-radius:50%;animation:igdot 2s infinite }
// // @keyframes igdot { 0%,100%{box-shadow:0 0 0 0 rgba(248,108,61,.5)} 50%{box-shadow:0 0 0 8px transparent} }
// // .ig-hd h2 { font-family:"Playfair Display",Georgia,serif;font-size:clamp(28px,4vw,52px);color:#fff;line-height:1.1;font-weight:900;margin:0 }
// // .ig-hd p { color:rgba(255,200,160,.42);font-size:15px;line-height:1.75;max-width:320px;font-family:"DM Sans",sans-serif }

// // /* slider viewport */
// // .ig-vp { overflow:hidden }
// // .ig-track {
// //   display:flex;
// //   gap:24px;
// //   transition:transform .7s cubic-bezier(.77,0,.175,1);
// //   will-change:transform;
// // }

// // /* ── PHONE CARD ── */
// // .ig-card {
// //   flex-shrink: 0;
// //   width: 320px;
// //   border-radius: 24px;
// //   overflow: hidden;
// //   background: #fff;
// //   box-shadow: 0 24px 64px rgba(0,0,0,.4), 0 4px 16px rgba(0,0,0,.2);
// //   transition: transform .4s cubic-bezier(.34,1.56,.64,1), box-shadow .4s;
// //   cursor: pointer;
// //   position: relative;
// // }
// // .ig-card:hover {
// //   transform: translateY(-8px) scale(1.02);
// //   box-shadow: 0 40px 80px rgba(0,0,0,.5), 0 8px 24px rgba(0,0,0,.25);
// // }

// // /* instagram top bar */
// // .ig-topbar {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   padding: 10px 14px 8px;
// //   background: #fff;
// //   border-bottom: 1px solid #f0f0f0;
// // }
// // .ig-topbar-logo {
// //   font-family: "DM Sans", sans-serif;
// //   font-size: 16px;
// //   font-weight: 700;
// //   background: linear-gradient(135deg, #405DE6, #C13584, #E1306C, #FD1D1D, #F77737);
// //   -webkit-background-clip: text;
// //   -webkit-text-fill-color: transparent;
// //   background-clip: text;
// //   letter-spacing: -.3px;
// // }
// // .ig-topbar-icons { display:flex;gap:12px;align-items:center }
// // .ig-topbar-icons span { font-size:16px;cursor:pointer;opacity:.7 }

// // /* profile section */
// // .ig-profile { padding: 14px 14px 10px }
// // .ig-profile-top { display:flex;align-items:center;gap:14px;margin-bottom:12px }
// // .ig-avatar-wrap { position:relative;flex-shrink:0 }
// // .ig-avatar {
// //   width: 62px; height: 62px;
// //   border-radius: 50%;
// //   object-fit: cover;
// //   padding: 2px;
// //   background: linear-gradient(135deg, #405DE6, #C13584, #E1306C, #FD1D1D, #F77737);
// // }
// // .ig-avatar-inner {
// //   width: 100%; height: 100%;
// //   border-radius: 50%;
// //   object-fit: cover;
// //   border: 2px solid #fff;
// //   display: block;
// // }
// // .ig-stats { display:flex;gap:16px;flex:1;justify-content:space-around }
// // .ig-stat { text-align:center }
// // .ig-stat-num { font-family:"DM Sans",sans-serif;font-size:15px;font-weight:700;color:#0A0A0A;line-height:1 }
// // .ig-stat-lbl { font-family:"DM Sans",sans-serif;font-size:11px;color:#666;margin-top:2px }

// // /* name + bio */
// // .ig-username { font-family:"DM Sans",sans-serif;font-size:13px;font-weight:700;color:#0A0A0A;display:flex;align-items:center;gap:4px }
// // .ig-verified { font-size:12px }
// // .ig-category { font-family:"DM Sans",sans-serif;font-size:11px;color:#737373;margin-top:1px }
// // .ig-bio { font-family:"DM Sans",sans-serif;font-size:11.5px;color:#262626;line-height:1.5;margin-top:6px;white-space:pre-line }

// // /* follow button */
// // .ig-follow-row { display:flex;gap:6px;margin-top:10px }
// // .ig-btn-follow {
// //   flex:1;padding:6px 12px;border-radius:8px;
// //   font-family:"DM Sans",sans-serif;font-size:13px;font-weight:700;
// //   border:none;cursor:pointer;transition:opacity .2s;
// // }
// // .ig-btn-follow.primary { background:#0095F6;color:#fff }
// // .ig-btn-follow.secondary { background:#EFEFEF;color:#262626 }
// // .ig-btn-follow:hover { opacity:.85 }

// // /* highlights */
// // .ig-highlights { padding:10px 14px;overflow-x:auto;display:flex;gap:14px;scrollbar-width:none }
// // .ig-highlights::-webkit-scrollbar { display:none }
// // .ig-hl { display:flex;flex-direction:column;align-items:center;gap:5px;flex-shrink:0;cursor:pointer }
// // .ig-hl-ring {
// //   width: 52px; height: 52px;
// //   border-radius: 50%;
// //   padding: 2px;
// //   background: linear-gradient(135deg, #405DE6, #C13584, #E1306C, #FD1D1D, #F77737);
// // }
// // .ig-hl-inner {
// //   width: 100%; height: 100%;
// //   border-radius: 50%;
// //   overflow: hidden;
// //   border: 2px solid #fff;
// // }
// // .ig-hl-inner img { width:100%;height:100%;object-fit:cover;display:block }
// // .ig-hl-label { font-family:"DM Sans",sans-serif;font-size:10px;color:#262626;text-align:center;max-width:56px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap }

// // /* tab row */
// // .ig-tabs { display:flex;border-top:1px solid #DBDBDB;border-bottom:1px solid #DBDBDB }
// // .ig-tab { flex:1;padding:9px 0;display:flex;justify-content:center;align-items:center;font-size:20px;cursor:pointer;border-bottom:2px solid transparent;transition:border-color .2s }
// // .ig-tab.active { border-color:#262626 }

// // /* feed grid */
// // .ig-feed { display:grid;grid-template-columns:repeat(3,1fr);gap:2px;background:#fff }
// // .ig-feed-img { width:100%;aspect-ratio:1;object-fit:cover;display:block;transition:filter .3s }
// // .ig-card:hover .ig-feed-img { filter:brightness(.95) }

// // /* client tag badge */
// // .ig-card-badge {
// //   position:absolute;top:12px;right:12px;
// //   padding:4px 10px;border-radius:100px;
// //   font-family:"DM Sans",sans-serif;font-size:10px;font-weight:700;
// //   letter-spacing:.5px;text-transform:uppercase;
// //   color:#fff;
// //   box-shadow:0 2px 12px rgba(0,0,0,.3);
// //   z-index:2;
// // }

// // /* nav */
// // .ig-nav { display:flex;align-items:center;gap:10px;margin-top:36px;justify-content:center }
// // .ig-nbtn {
// //   width:44px;height:44px;border-radius:50%;
// //   border:1.5px solid rgba(248,108,61,.25);
// //   background:rgba(248,108,61,.06);
// //   cursor:pointer;display:flex;align-items:center;justify-content:center;
// //   color:rgba(255,140,80,.7);
// //   transition:all .25s cubic-bezier(.34,1.56,.64,1);
// // }
// // .ig-nbtn:hover { background:linear-gradient(135deg,#F86C3D,#D9572E);border-color:transparent;color:#fff;transform:scale(1.1) }
// // .ig-dot {
// //   height:8px;border-radius:100px;border:none;cursor:pointer;
// //   background:rgba(255,255,255,.15);
// //   transition:background .3s,width .3s;padding:0;flex-shrink:0;
// // }
// // .ig-dot.on { background:linear-gradient(90deg,#F86C3D,#FF8A5C) }

// // /* responsive */
// // @media(max-width:768px) {
// //   .ig-in { padding:0 20px }
// //   .ig-hd { flex-direction:column;align-items:flex-start;margin-bottom:36px }
// //   .ig-card { width:280px }
// // }
// // @media(max-width:480px) {
// //   .ig-sec { padding:70px 0 90px }
// //   .ig-card { width:260px }
// // }
// // `;

// // /* ─────────────────────────────────────────────────────
// //    PHONE CARD COMPONENT
// // ───────────────────────────────────────────────────── */
// // const IGCard = ({ p }) => (
// //   <div className="ig-card">
// //     {/* client tag badge */}
// //     <div
// //       className="ig-card-badge"
// //       style={{ background: p.accentColor + "dd" }}
// //     >
// //       {p.tag}
// //     </div>

// //     {/* Instagram top bar */}
// //     <div className="ig-topbar">
// //       <span className="ig-topbar-logo">Instagram</span>
// //       <div className="ig-topbar-icons">
// //         <span>➕</span>
// //         <span>❤️</span>
// //         <span>💬</span>
// //       </div>
// //     </div>

// //     {/* Profile row */}
// //     <div className="ig-profile">
// //       <div className="ig-profile-top">
// //         {/* Avatar with gradient ring */}
// //         <div className="ig-avatar-wrap">
// //           <div className="ig-avatar">
// //             <img src={p.avatar} alt={p.name} className="ig-avatar-inner" />
// //           </div>
// //         </div>
// //         {/* Stats */}
// //         <div className="ig-stats">
// //           {[["posts", p.posts], ["followers", p.followers], ["following", p.following]].map(([l, v]) => (
// //             <div key={l} className="ig-stat">
// //               <div className="ig-stat-num">{v}</div>
// //               <div className="ig-stat-lbl">{l}</div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* Name + bio */}
// //       <div className="ig-username">
// //         {p.handle} {p.verified && <span className="ig-verified">✔️</span>}
// //       </div>
// //       <div className="ig-category">{p.category}</div>
// //       <div className="ig-bio">{p.bio}</div>

// //       {/* Follow row */}
// //       <div className="ig-follow-row">
// //         <button className="ig-btn-follow primary">Follow</button>
// //         <button className="ig-btn-follow secondary">Message</button>
// //         <button className="ig-btn-follow secondary" style={{ flex: "0 0 36px", padding: "6px" }}>▾</button>
// //       </div>
// //     </div>

// //     {/* Highlights */}
// //     <div className="ig-highlights">
// //       {p.highlights.map((h, i) => (
// //         <div key={i} className="ig-hl">
// //           <div className="ig-hl-ring">
// //             <div className="ig-hl-inner">
// //               <img src={h.img} alt={h.label} />
// //             </div>
// //           </div>
// //           <span className="ig-hl-label">{h.label}</span>
// //         </div>
// //       ))}
// //     </div>

// //     {/* Tabs */}
// //     <div className="ig-tabs">
// //       <div className="ig-tab active">⊞</div>
// //       <div className="ig-tab">▷</div>
// //       <div className="ig-tab">🏷️</div>
// //     </div>

// //     {/* Feed grid */}
// //     <div className="ig-feed">
// //       {p.feed.map((src, i) => (
// //         <img key={i} src={src} alt="" className="ig-feed-img" />
// //       ))}
// //     </div>
// //   </div>
// // );

// // /* ─────────────────────────────────────────────────────
// //    REVEAL HELPER
// // ───────────────────────────────────────────────────── */
// // const RC = ({ children, delay = 0, style = {} }) => {
// //   const ref = useRef();
// //   const [on, setOn] = useState(false);
// //   useEffect(() => {
// //     const el = ref.current;
// //     const o = new IntersectionObserver(
// //       es => { es.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); o.unobserve(el); } }); },
// //       { threshold: 0.1 }
// //     );
// //     if (el) o.observe(el);
// //     return () => { if (el) o.unobserve(el); };
// //   }, [delay]);
// //   return (
// //     <div ref={ref} style={{
// //       transition: "opacity 900ms cubic-bezier(0.4,0,0.2,1), transform 900ms cubic-bezier(0.4,0,0.2,1)",
// //       opacity: on ? 1 : 0, transform: on ? "translateY(0)" : "translateY(48px)",
// //       ...style
// //     }}>
// //       {children}
// //     </div>
// //   );
// // };

// // /* ─────────────────────────────────────────────────────
// //    MAIN COMPONENT
// // ───────────────────────────────────────────────────── */
// // const InstagramShowcase = () => {
// //   const [idx, setIdx] = useState(0);
// //   const VISIBLE = 3;
// //   const MAX = PROFILES.length - VISIBLE;
// //   const CARD_W = 320 + 24; // card width + gap

// //   /* auto-slide every 3s */
// //   useEffect(() => {
// //     const t = setInterval(() => {
// //       setIdx(p => (p >= MAX ? 0 : p + 1));
// //     }, 3000);
// //     return () => clearInterval(t);
// //   }, [MAX]);

// //   return (
// //     <>
// //       <style>{CSS}</style>
// //       <section className="ig-sec">
// //         <div className="ig-bg1" /><div className="ig-bg2" />
// //         <div className="ig-in">

// //           {/* Header */}
// //           <div className="ig-hd">
// //             <RC>
// //               <div className="ig-hd-left">
// //                 <div className="ig-tag"><span className="ig-tag-dot" /> Client Instagram Pages</div>
// //                 <h2>
// //                   Real Results,{" "}
// //                   <span style={{
// //                     background: "linear-gradient(135deg,#F86C3D,#FF8A5C)",
// //                     WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text"
// //                   }}>
// //                     Real Profiles
// //                   </span>
// //                 </h2>
// //               </div>
// //             </RC>
// //             <RC delay={150}>
// //               <p>We manage and grow Instagram pages that convert — a live snapshot of client feeds we've built from scratch.</p>
// //             </RC>
// //           </div>

// //           {/* Slider */}
// //           <RC delay={200}>
// //             <div className="ig-vp">
// //               <div
// //                 className="ig-track"
// //                 style={{ transform: `translateX(-${idx * CARD_W}px)` }}
// //               >
// //                 {PROFILES.map((p, i) => (
// //                   <IGCard key={i} p={p} />
// //                 ))}
// //               </div>
// //             </div>
// //           </RC>

// //           {/* Nav */}
// //           <RC delay={300}>
// //             <div className="ig-nav">
// //               <button className="ig-nbtn" onClick={() => setIdx(p => Math.max(0, p - 1))}>
// //                 <ChevronLeft size={18} />
// //               </button>
// //               <button className="ig-nbtn" onClick={() => setIdx(p => Math.min(MAX, p + 1))}>
// //                 <ChevronRight size={18} />
// //               </button>
// //               {Array.from({ length: MAX + 1 }).map((_, i) => (
// //                 <button
// //                   key={i}
// //                   className={"ig-dot" + (idx === i ? " on" : "")}
// //                   style={{ width: idx === i ? "24px" : "8px" }}
// //                   onClick={() => setIdx(i)}
// //                 />
// //               ))}
// //             </div>
// //           </RC>

// //         </div>
// //       </section>
// //     </>
// //   );
// // };

// // export default InstagramShowcase;

// import React, { useState, useEffect, useRef } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";
// import sia from './insta/sia.png';
// import redstar from './insta/redstar.png';
// import carnival from './insta/carnival.png';
// import nihira from './insta/nihira.png';
// import amista from './insta/amista.png';
// import orion from './insta/orion.png';

// /*
//   USAGE:
//   1. Import your screenshot images at top of this file:
//      import client1 from "./screenshots/designwalls.png";
//      import client2 from "./screenshots/dps.png";
//      ... etc

//   2. Replace the src values in SCREENSHOTS array below with your imports.

//   3. Drop <InstagramShowcase /> anywhere in your JSX.
// */

// /* ── ADD YOUR SCREENSHOT IMPORTS HERE ── */
// // import sc1 from "./screenshots/client1.png";
// // import sc2 from "./screenshots/client2.png";
// // ...

// /* ── SCREENSHOTS — replace src with your actual imports ── */
// const SCREENSHOTS = [
//   { src: sia, label: "Sia Clinics" },
//   { src: redstar, label: "Red Star Furniture" },
//   { src: carnival, label: "Castle Carnival" },
//   { src: nihira, label: "Nihira Realtors" },
//   { src: amista, label: "Amista" },
//   { src: orion, label: "Orion Studios" },
// ];
// //   { src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=750&fit=crop", label: "Triumph Hyderabad" },
// // ];

// /* ── CSS ── */
// const CSS = `
// .ig-sec {
//   padding: 100px 0 120px;
//   background: #0D0806;
//   overflow: hidden;
//   position: relative;
// }
// .ig-sec * { box-sizing: border-box; margin: 0; padding: 0; }

// /* bg orbs */
// .ig-orb1 { position:absolute;top:-160px;right:-120px;width:500px;height:500px;border-radius:50%;background:radial-gradient(circle,rgba(248,108,61,.1),transparent 70%);pointer-events:none;animation:igob 8s ease-in-out infinite }
// .ig-orb2 { position:absolute;bottom:-80px;left:-60px;width:380px;height:380px;border-radius:50%;background:radial-gradient(circle,rgba(217,87,46,.07),transparent 70%);pointer-events:none;animation:igob 11s ease-in-out infinite reverse }
// @keyframes igob { 0%,100%{transform:scale(1)} 50%{transform:scale(1.1)} }

// .ig-inner { max-width:1280px;margin:0 auto;padding:0 44px;position:relative;z-index:1 }

// /* header */
// .ig-header { display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:56px;flex-wrap:wrap;gap:24px }
// .ig-tag { display:inline-flex;align-items:center;gap:7px;background:rgba(248,108,61,.1);border:1px solid rgba(248,108,61,.28);border-radius:100px;padding:6px 16px;font-family:"DM Sans",sans-serif;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#FF8A5C;margin-bottom:14px }
// .ig-tag-dot { width:6px;height:6px;background:#F86C3D;border-radius:50%;animation:igdot 2s infinite }
// @keyframes igdot { 0%,100%{box-shadow:0 0 0 0 rgba(248,108,61,.5)} 50%{box-shadow:0 0 0 8px transparent} }
// .ig-title { font-family:"Playfair Display",Georgia,serif;font-size:clamp(28px,4vw,52px);font-weight:900;line-height:1.1;color:#fff }
// .ig-title span { background:linear-gradient(135deg,#F86C3D,#FF8A5C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text }
// .ig-desc { color:rgba(255,200,160,.45);font-size:15px;line-height:1.75;max-width:320px;font-family:"DM Sans",sans-serif }

// /* slider viewport */
// .ig-viewport { overflow:hidden }
// .ig-track { display:flex;gap:32px;transition:transform .7s cubic-bezier(.77,0,.175,1);will-change:transform }

// /* ══ PHONE SHELL ══ */
// .ig-phone {
//   flex-shrink: 0;
//   width: 280px;
//   position: relative;
//   cursor: pointer;
//   transition: transform .4s cubic-bezier(.34,1.56,.64,1);
// }
// .ig-phone:hover { transform: translateY(-10px) scale(1.02); }

// /* phone frame SVG-style with CSS */
// .ig-phone-frame {
//   position: relative;
//   width: 100%;
//   /* 19.5:9 aspect ratio — typical modern smartphone */
//   padding-top: calc(100% * 19.5 / 9);
//   border-radius: 36px;
//   background: #1a1a1a;
//   box-shadow:
//     0 0 0 8px #1a1a1a,
//     0 0 0 10px #2a2a2a,
//     0 28px 80px rgba(0,0,0,.7),
//     0 4px 20px rgba(0,0,0,.4),
//     inset 0 0 0 1px rgba(255,255,255,.06);
//   overflow: hidden;
//   transition: box-shadow .4s;
// }
// .ig-phone:hover .ig-phone-frame {
//   box-shadow:
//     0 0 0 8px #222,
//     0 0 0 10px #333,
//     0 48px 100px rgba(0,0,0,.8),
//     0 8px 32px rgba(248,108,61,.12),
//     inset 0 0 0 1px rgba(255,255,255,.1);
// }

// /* dynamic island / notch */
// .ig-notch {
//   position: absolute;
//   top: 10px;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 90px;
//   height: 24px;
//   background: #0a0a0a;
//   border-radius: 100px;
//   z-index: 10;
//   box-shadow: 0 0 0 1px rgba(255,255,255,.05);
// }
// /* camera dot inside notch */
// .ig-notch::after {
//   content: "";
//   position: absolute;
//   right: 14px;
//   top: 50%;
//   transform: translateY(-50%);
//   width: 10px;
//   height: 10px;
//   border-radius: 50%;
//   background: #1a1a1a;
//   box-shadow: 0 0 0 2px rgba(255,255,255,.05), inset 0 0 4px rgba(0,200,255,.15);
// }

// /* screenshot fills the frame */
// .ig-screenshot {
//   position: absolute;
//   inset: 0;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   object-position: top center;
//   display: block;
//   border-radius: 28px;
// }

// /* side buttons */
// .ig-btn-vol {
//   position: absolute;
//   left: -10px;
//   top: 22%;
//   width: 4px;
//   border-radius: 2px;
//   background: #2a2a2a;
//   box-shadow: inset 0 0 0 1px rgba(255,255,255,.05);
// }
// .ig-btn-vol.v1 { height: 32px; top: 22% }
// .ig-btn-vol.v2 { height: 32px; top: calc(22% + 44px) }
// .ig-btn-pwr {
//   position: absolute;
//   right: -10px;
//   top: 28%;
//   width: 4px;
//   height: 56px;
//   border-radius: 2px;
//   background: #2a2a2a;
//   box-shadow: inset 0 0 0 1px rgba(255,255,255,.05);
// }

// /* bottom home bar */
// .ig-home-bar {
//   position: absolute;
//   bottom: 10px;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 100px;
//   height: 4px;
//   border-radius: 100px;
//   background: rgba(255,255,255,.4);
//   z-index: 10;
// }

// /* screen edge reflection */
// .ig-screen-glare {
//   position: absolute;
//   top: 0; left: 0; right: 0;
//   height: 40%;
//   background: linear-gradient(160deg, rgba(255,255,255,.04) 0%, transparent 60%);
//   border-radius: 28px 28px 0 0;
//   pointer-events: none;
//   z-index: 5;
// }

// /* label under phone */
// .ig-phone-label {
//   text-align: center;
//   margin-top: 16px;
//   font-family: "DM Sans", sans-serif;
//   font-size: 13px;
//   font-weight: 600;
//   color: rgba(255,200,160,.5);
//   letter-spacing: .3px;
//   transition: color .2s;
// }
// .ig-phone:hover .ig-phone-label { color: #F86C3D; }

// /* nav */
// .ig-nav { display:flex;align-items:center;gap:10px;margin-top:44px;justify-content:center }
// .ig-nbtn { width:44px;height:44px;border-radius:50%;border:1.5px solid rgba(248,108,61,.25);background:rgba(248,108,61,.06);cursor:pointer;display:flex;align-items:center;justify-content:center;color:rgba(255,140,80,.7);transition:all .25s cubic-bezier(.34,1.56,.64,1) }
// .ig-nbtn:hover { background:linear-gradient(135deg,#F86C3D,#D9572E);border-color:transparent;color:#fff;transform:scale(1.1) }
// .ig-dot { height:8px;border-radius:100px;border:none;cursor:pointer;background:rgba(255,255,255,.15);transition:background .3s,width .3s;padding:0;flex-shrink:0 }
// .ig-dot.on { background:linear-gradient(90deg,#F86C3D,#FF8A5C) }

// /* ── RESPONSIVE ── */
// @media(max-width:1100px) {
//   .ig-inner { padding:0 32px }
//   .ig-phone { width:240px }
// }
// @media(max-width:768px) {
//   .ig-sec { padding:70px 0 90px }
//   .ig-inner { padding:0 20px }
//   .ig-header { flex-direction:column;align-items:flex-start;margin-bottom:36px }
//   .ig-track { gap:20px }
//   .ig-phone { width:200px }
//   .ig-phone-frame { border-radius:28px }
//   .ig-screenshot { border-radius:22px }
//   .ig-notch { width:72px;height:20px }
// }
// @media(max-width:480px) {
//   .ig-phone { width:170px }
//   .ig-phone-frame { border-radius:24px }
//   .ig-screenshot { border-radius:18px }
//   .ig-title { font-size:28px }
// }
// `;

// /* ── REVEAL ── */
// const RC = ({ children, delay = 0 }) => {
//   const ref = useRef();
//   const [on, setOn] = useState(false);
//   useEffect(() => {
//     const el = ref.current;
//     const o = new IntersectionObserver(
//       es => { es.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); o.unobserve(el); } }); },
//       { threshold: 0.1 }
//     );
//     if (el) o.observe(el);
//     return () => { if (el) o.unobserve(el); };
//   }, [delay]);
//   return (
//     <div ref={ref} style={{
//       transition: "opacity 900ms cubic-bezier(0.4,0,0.2,1), transform 900ms cubic-bezier(0.4,0,0.2,1)",
//       opacity: on ? 1 : 0,
//       transform: on ? "none" : "translateY(48px)",
//     }}>
//       {children}
//     </div>
//   );
// };

// /* ── PHONE CARD ── */
// const PhoneCard = ({ src, label }) => (
//   <div className="ig-phone">
//     {/* side buttons */}
//     <div className="ig-btn-vol v1" />
//     <div className="ig-btn-vol v2" />
//     <div className="ig-btn-pwr" />

//     <div className="ig-phone-frame">
//       {/* notch */}
//       <div className="ig-notch" />
//       {/* screenshot */}
//       <img className="ig-screenshot" src={src} alt={label} />
//       {/* glare overlay */}
//       <div className="ig-screen-glare" />
//       {/* home bar */}
//       <div className="ig-home-bar" />
//     </div>

//     <div className="ig-phone-label">{label}</div>
//   </div>
// );

// /* ── MAIN COMPONENT ── */
// const InstagramShowcase = () => {
//   const [idx, setIdx] = useState(0);
//   const VISIBLE = 3;
//   const CARD_W = 280 + 32;   /* width + gap — update if you change .ig-phone width */
//   const MAX = SCREENSHOTS.length - VISIBLE;

//   /* auto-slide */
//   useEffect(() => {
//     const t = setInterval(() => setIdx(p => (p >= MAX ? 0 : p + 1)), 3000);
//     return () => clearInterval(t);
//   }, [MAX]);

//   return (
//     <>
//       <style>{CSS}</style>
//       <section className="ig-sec">
//         <div className="ig-orb1" /><div className="ig-orb2" />
//         <div className="ig-inner">

//           {/* Header */}
//           <div className="ig-header">
//             <RC>
//               <div>
//                 <div className="ig-tag"><span className="ig-tag-dot" />Client Instagram Pages</div>
//                 <h2 className="ig-title">
//                   Real Results,{" "}
//                   <span>Real Profiles</span>
//                 </h2>
//               </div>
//             </RC>
//             <RC delay={150}>
//               <p className="ig-desc">
//                 We manage and grow Instagram pages that convert — screenshots straight from our clients' feeds.
//               </p>
//             </RC>
//           </div>

//           {/* Slider */}
//           <RC delay={200}>
//             <div className="ig-viewport">
//               <div
//                 className="ig-track"
//                 style={{ transform: `translateX(-${idx * CARD_W}px)` }}
//               >
//                 {SCREENSHOTS.map((s, i) => (
//                   <PhoneCard key={i} src={s.src} label={s.label} />
//                 ))}
//               </div>
//             </div>
//           </RC>

//           {/* Nav */}
//           <RC delay={300}>
//             <div className="ig-nav">
//               <button className="ig-nbtn" onClick={() => setIdx(p => Math.max(0, p - 1))}>
//                 <ChevronLeft size={18} />
//               </button>
//               <button className="ig-nbtn" onClick={() => setIdx(p => Math.min(MAX, p + 1))}>
//                 <ChevronRight size={18} />
//               </button>
//               {Array.from({ length: MAX + 1 }).map((_, i) => (
//                 <button
//                   key={i}
//                   className={"ig-dot" + (idx === i ? " on" : "")}
//                   style={{ width: idx === i ? "24px" : "8px" }}
//                   onClick={() => setIdx(i)}
//                 />
//               ))}
//             </div>
//           </RC>

//         </div>
//       </section>
//     </>
//   );
// };

// export default InstagramShowcase;

import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import sia from './insta/sia.png';
import redstar from './insta/redstar.png';
import carnival from './insta/carnival.png';
import nihira from './insta/nihira.png';
import amista from './insta/amista.png';
import orion from './insta/orion.png';

/*
  USAGE:
  1. Import your screenshot images:
     import sc1 from "./screenshots/client1.png";
  2. Replace src values in SCREENSHOTS array below.
  3. Add <InstagramShowcase /> anywhere in your JSX.
*/

// const SCREENSHOTS = [
//   { src: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&h=780&fit=crop", label: "Design Walls" },
//   { src: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=400&h=780&fit=crop", label: "DPS Amaravati" },
//   { src: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=780&fit=crop", label: "Hyd Art Gallery" },
//   { src: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400&h=780&fit=crop", label: "Millet Marvels" },
//   { src: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&h=780&fit=crop", label: "Zuri Skin Clinic" },
//   { src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=780&fit=crop", label: "Triumph Hyderabad" },
// ];
const SCREENSHOTS = [
  { src: sia, label: "Sia Clinics" },
  { src: redstar, label: "Red Star Furniture" },
  { src: carnival, label: "Castle Carnival" },
  { src: nihira, label: "Nihira Realtors" },
  { src: amista, label: "Amista" },
  { src: orion, label: "Orion Studios" },
];

const CSS = `
.ig-sec {
  padding: 100px 0 120px;
  background: #0D0806;
  overflow: hidden;
  position: relative;
}
.ig-sec * { box-sizing: border-box; margin: 0; padding: 0; }

.ig-orb1 { position:absolute;top:-160px;right:-120px;width:500px;height:500px;border-radius:50%;background:radial-gradient(circle,rgba(248,108,61,.1),transparent 70%);pointer-events:none;animation:igob 8s ease-in-out infinite }
.ig-orb2 { position:absolute;bottom:-80px;left:-60px;width:380px;height:380px;border-radius:50%;background:radial-gradient(circle,rgba(217,87,46,.07),transparent 70%);pointer-events:none;animation:igob 11s ease-in-out infinite reverse }
@keyframes igob { 0%,100%{transform:scale(1)} 50%{transform:scale(1.1)} }

.ig-inner { max-width:1280px;margin:0 auto;padding:0 44px;position:relative;z-index:1 }

/* header */
.ig-header { display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:56px;flex-wrap:wrap;gap:24px }
.ig-tag { display:inline-flex;align-items:center;gap:7px;background:rgba(248,108,61,.1);border:1px solid rgba(248,108,61,.28);border-radius:100px;padding:6px 16px;font-family:"DM Sans",sans-serif;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#FF8A5C;margin-bottom:14px }
.ig-tag-dot { width:6px;height:6px;background:#F86C3D;border-radius:50%;animation:igdot 2s infinite }
@keyframes igdot { 0%,100%{box-shadow:0 0 0 0 rgba(248,108,61,.5)} 50%{box-shadow:0 0 0 8px transparent} }
.ig-title { font-family:"Playfair Display",Georgia,serif;font-size:clamp(28px,4vw,52px);font-weight:900;line-height:1.1;color:#fff }
.ig-title span { background:linear-gradient(135deg,#F86C3D,#FF8A5C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text }
.ig-desc { color:rgba(255,200,160,.45);font-size:15px;line-height:1.75;max-width:320px;font-family:"DM Sans",sans-serif }

/* slider */
.ig-viewport { overflow:hidden }
.ig-track { display:flex;gap:28px;transition:transform .7s cubic-bezier(.77,0,.175,1);will-change:transform }

/* ══ ANDROID PHONE SHELL ══ */
.ig-phone {
  flex-shrink: 0;
  width: 260px;
  position: relative;
  cursor: pointer;
  transition: transform .4s cubic-bezier(.34,1.56,.64,1);
}
.ig-phone:hover { transform: translateY(-10px); }

/* outer bezel — flat rectangular Android style */
.ig-bezel {
  position: relative;
  width: 100%;
  padding-top: calc(100% * 20 / 9); /* 20:9 android ratio */
  background: #111;
  border-radius: 18px;
  box-shadow:
    0 0 0 2px #1e1e1e,
    0 0 0 4px #2a2a2a,
    0 0 0 5px #1a1a1a,
    0 32px 72px rgba(0,0,0,.75),
    0 4px 16px rgba(0,0,0,.5);
  transition: box-shadow .4s;
}
.ig-phone:hover .ig-bezel {
  box-shadow:
    0 0 0 2px #222,
    0 0 0 4px #333,
    0 0 0 5px #1a1a1a,
    0 48px 90px rgba(0,0,0,.85),
    0 8px 28px rgba(248,108,61,.1);
}

/* screen area inside bezel */
.ig-screen {
  position: absolute;
  /* small inset so bezel is visible */
  top: 6px; left: 5px; right: 5px; bottom: 6px;
  border-radius: 14px;
  overflow: hidden;
  background: #000;
}

/* punch-hole camera — top center */
.ig-punchhole {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 10px;
  height: 10px;
  background: #0a0a0a;
  border-radius: 50%;
  z-index: 10;
  box-shadow: 0 0 0 1.5px rgba(255,255,255,.08);
}

/* screenshot */
.ig-screenshot {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
}

/* subtle glare */
.ig-glare {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,.04) 0%, transparent 50%);
  pointer-events: none;
  z-index: 5;
  border-radius: 14px;
}

/* power button — right side */
.ig-btn-power {
  position: absolute;
  right: -4px;
  top: 25%;
  width: 3px;
  height: 44px;
  background: #2a2a2a;
  border-radius: 0 3px 3px 0;
}

/* volume buttons — left side */
.ig-btn-vol1 {
  position: absolute;
  left: -4px;
  top: 20%;
  width: 3px;
  height: 28px;
  background: #2a2a2a;
  border-radius: 3px 0 0 3px;
}
.ig-btn-vol2 {
  position: absolute;
  left: -4px;
  top: calc(20% + 38px);
  width: 3px;
  height: 28px;
  background: #2a2a2a;
  border-radius: 3px 0 0 3px;
}

/* bottom speaker dots */
.ig-speaker {
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
  align-items: center;
  z-index: 10;
}
.ig-speaker span {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(255,255,255,.2);
  display: block;
}

/* label */
.ig-label {
  text-align: center;
  margin-top: 14px;
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255,200,160,.45);
  letter-spacing: .3px;
  transition: color .2s;
}
.ig-phone:hover .ig-label { color: #F86C3D; }

/* nav */
.ig-nav { display:flex;align-items:center;gap:10px;margin-top:44px;justify-content:center }
.ig-nbtn { width:44px;height:44px;border-radius:50%;border:1.5px solid rgba(248,108,61,.25);background:rgba(248,108,61,.06);cursor:pointer;display:flex;align-items:center;justify-content:center;color:rgba(255,140,80,.7);transition:all .25s cubic-bezier(.34,1.56,.64,1) }
.ig-nbtn:hover { background:linear-gradient(135deg,#F86C3D,#D9572E);border-color:transparent;color:#fff;transform:scale(1.1) }
.ig-dot { height:8px;border-radius:100px;border:none;cursor:pointer;background:rgba(255,255,255,.15);transition:background .3s,width .3s;padding:0;flex-shrink:0 }
.ig-dot.on { background:linear-gradient(90deg,#F86C3D,#FF8A5C) }

/* responsive */
@media(max-width:1100px) {
  .ig-inner { padding:0 32px }
  .ig-phone { width:220px }
}
@media(max-width:768px) {
  .ig-sec { padding:70px 0 90px }
  .ig-inner { padding:0 20px }
  .ig-header { flex-direction:column;align-items:flex-start;margin-bottom:36px }
  .ig-track { gap:18px }
  .ig-phone { width:185px }
  .ig-bezel { border-radius:14px }
  .ig-screen { border-radius:10px;top:5px;left:4px;right:4px;bottom:5px }
}
@media(max-width:480px) {
  .ig-phone { width:155px }
  .ig-bezel { border-radius:12px }
  .ig-screen { border-radius:8px }
}
`;

const RC = ({ children, delay = 0 }) => {
  const ref = useRef();
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const o = new IntersectionObserver(
      es => { es.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); o.unobserve(el); } }); },
      { threshold: 0.1 }
    );
    if (el) o.observe(el);
    return () => { if (el) o.unobserve(el); };
  }, [delay]);
  return (
    <div ref={ref} style={{
      transition: "opacity 900ms cubic-bezier(0.4,0,0.2,1), transform 900ms cubic-bezier(0.4,0,0.2,1)",
      opacity: on ? 1 : 0,
      transform: on ? "none" : "translateY(48px)",
    }}>
      {children}
    </div>
  );
};

const PhoneCard = ({ src, label }) => (
  <div className="ig-phone">
    {/* buttons */}
    <div className="ig-btn-power" />
    <div className="ig-btn-vol1" />
    <div className="ig-btn-vol2" />

    <div className="ig-bezel">
      <div className="ig-screen">
        <div className="ig-punchhole" />
        <img className="ig-screenshot" src={src} alt={label} />
        <div className="ig-glare" />
      </div>

      {/* speaker grille */}
      <div className="ig-speaker">
        {Array.from({ length: 7 }).map((_, i) => <span key={i} />)}
      </div>
    </div>

    <div className="ig-label">{label}</div>
  </div>
);

const InstagramShowcase = () => {
  const [idx, setIdx] = useState(0);
  const VISIBLE = 3;
  const CARD_W = 260 + 28;
  const MAX = SCREENSHOTS.length - VISIBLE;

  useEffect(() => {
    const t = setInterval(() => setIdx(p => (p >= MAX ? 0 : p + 1)), 3000);
    return () => clearInterval(t);
  }, [MAX]);

  return (
    <>
      <style>{CSS}</style>
      <section className="ig-sec">
        <div className="ig-orb1" /><div className="ig-orb2" />
        <div className="ig-inner">

          <div className="ig-header">
            <RC>
              <div>
                <div className="ig-tag"><span className="ig-tag-dot" />Client Instagram Pages</div>
                <h2 className="ig-title">Real Results, <span>Real Profiles</span></h2>
              </div>
            </RC>
            <RC delay={150}>
              <p className="ig-desc">Screenshots straight from our clients' Instagram feeds — built and grown by Kanactify.</p>
            </RC>
          </div>

          <RC delay={200}>
            <div className="ig-viewport">
              <div
                className="ig-track"
                style={{ transform: `translateX(-${idx * CARD_W}px)` }}
              >
                {SCREENSHOTS.map((s, i) => (
                  <PhoneCard key={i} src={s.src} label={s.label} />
                ))}
              </div>
            </div>
          </RC>

          <RC delay={300}>
            <div className="ig-nav">
              <button className="ig-nbtn" onClick={() => setIdx(p => Math.max(0, p - 1))}>
                <ChevronLeft size={18} />
              </button>
              <button className="ig-nbtn" onClick={() => setIdx(p => Math.min(MAX, p + 1))}>
                <ChevronRight size={18} />
              </button>
              {Array.from({ length: MAX + 1 }).map((_, i) => (
                <button
                  key={i}
                  className={"ig-dot" + (idx === i ? " on" : "")}
                  style={{ width: idx === i ? "24px" : "8px" }}
                  onClick={() => setIdx(i)}
                />
              ))}
            </div>
          </RC>

        </div>
      </section>
    </>
  );
};

export default InstagramShowcase;